<template>
    <div>
        <hr>
        <div class=" overflow-hidden p-2">
            <div class="row">
                <div class="col-12 mb-2">
                    <h4 class="text-4 font-weight-400">Select your preferred method:</h4>
                </div>
                <div class="col-12 col-md-4 my-2">
                    <router-link to="/business/transact/excel" class="bg-white shadow-sm rounded-lg card border-0 card-body d-flex flex-row justify-content-center align-items-center hover:bg-accent hover:text-white">
                        <div class="p-2">
                            <i class="fas fa-file-excel fa-2x "></i>
                        </div>
                        <div class="d-inline-block ml-2">
                            <h6 class="mb-0 text-2">Pay From Batch</h6>
                            <small>Spreadsheet or Stored accounts</small>
                        </div>
                    </router-link>
                </div>

                <div class="col-12 col-md-4 my-2">
                    <router-link to="/business/transact/form" class=" bg-white shadow-sm rounded-lg card border-0 card-body d-flex flex-row justify-content-center align-items-center hover:bg-accent hover:text-white">
                        <div class="p-2">
                            <i class="fas fa-file-alt fa-2x "></i>
                        </div>
                        <div class="d-inline-block ml-2">
                            <h6 class="text-2 mb-0">Pay From Manual Input</h6>
                            <small>Manual or Stored accounts</small>
                        </div>
                    </router-link>
                </div>

                <div class="col-12 col-md-4 my-2">
                    <router-link to="/business/transact/history" class=" bg-white shadow-sm rounded-lg card border-0 card-body d-flex flex-row justify-content-center align-items-center hover:bg-accent hover:text-white">
                        <div class="p-2">
                            <i class="fas fa-history fa-2x "></i>
                        </div>
                        <div class="d-inline-block ml-2">
                            <h6 class="mb-0 text-2">Pay From Previous</h6>
                            <small>Previous bill payment</small>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
        <hr>
        <div class="mt-3">
            <div class="d-flex flex-column alert alert-info p-4">
                <h4 class="text-5 font-weight-400">Get started with Stored Accounts</h4>
                <div class="d-flex flex-column font-weight-300">
                <span>
                    Stored accounts allow businesses to manage frequently used account details for quick access and transactions.

                </span>
                    <span class="font-weight-400 mt-2">
                    3 Steps to Get Started:
                </span>
                    <ol >
                        <li>
                            Create a Group – Organize your stored accounts by creating a group that will hold related batches.
                        </li>
                        <li>
                            Add a Batch – Within a group, create a batch to categorize and manage a set of stored accounts.
                        </li>
                        <li>
                            Store Accounts – Add individual stored accounts to a batch for quick access and streamlined transactions.
                        </li>
                    </ol>
                    <span class="mt-2">
                   Start now – add a stored account or upload a batch!
                </span>
                    <span class="mt-3" >
                    <router-link
                        :to="`/business/stored-accounts/add`"
                        class="btn btn-primary btn-sm text-white shadow-none mr-2"
                    >
                        <i class="fas fa-plus-circle mr-2"></i>Add Account
                    </router-link>
                    <router-link
                        :to="`/business/stored-accounts/create-batch`"
                        class="btn btn-success btn-sm text-white shadow-none"
                    >
                        <i class="fas fa-layer-group mr-2"></i>Add Batch
                    </router-link>
                </span>
                </div>
            </div>
        </div>
    </div>


</template>

<script>

export default {
    name: "business-init",
}
</script>
